export type OrgBranding = {
  displayName: string | null;
  logoUrl: string | null;
};

export function parseOrgBranding(data: Record<string, unknown> | undefined): OrgBranding {
  const name = data?.displayName;
  const displayName = typeof name === 'string' && name.trim() ? name.trim() : null;
  const logo = data?.logoDataUrl;
  const logoUrl = typeof logo === 'string' && logo.startsWith('data:image/') ? logo : null;
  return { displayName, logoUrl };
}
